import { coreUsersIdMapSlice } from './update';

export const coreUsersIdMapReducers = coreUsersIdMapSlice.syncReducer;
